import React from "react";
import "./LoginHeader.scss";
import {MDBBox} from "mdbreact";
import {assetUrl} from "../../serviceApi";

const AngleLeft = assetUrl+"images/login-arrow-left.svg";
const CloseIcon = assetUrl+"images/login-cross-nav.svg";


class LoginHeader extends React.Component{

    render() {
        return(
            <MDBBox className="d-flex justify-content-between align-items-center  pb-3">
                <img src={AngleLeft} alt={"AngleLeft"} onClick={this.props.handleBackClick} />
                <img src={CloseIcon} alt={"CloseIcon"} onClick={this.props.handleCloseClick} />
            </MDBBox>
        );
    }
}

 export default LoginHeader;